import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function LocalizationLink() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        py: 12,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'primary.main',
        px: 1,
        gap: 6,
      }}
    >
      <Typography sx={{
        typography: {
          xs: 'h6',
          md: 'h4',
        },
        color: 'background.default',
      }}
      >
        {t('localization.title')}
      </Typography>
      <Typography sx={{
        typography: {
          xs: 'body1',
          md: 'h4',
        },
        color: 'background.default',
      }}
      >
        {t('localization.message')}
      </Typography>
    </Box>
  );
}

export default LocalizationLink;
